<div class="ex-chart-wrap">
  <div class="desc-box">
    <div class="desc" *ngIf="!titleBarShow && exList.length!=0 ">{{exList[0].cl_reg_time ? exList[0].cl_reg_time : '2016.00.00'}} 운동 기능 검사</div>
    <div class="desc" *ngIf="titleBarShow || exList.length==0">{{testData ? testData[2]:'2016.00.00'}} 운동 기능 검사</div>
  </div>
  <div class="chart-box">
    <polar-chart class="chart" [testData]="testData" (onClickEvent)="onClickEvent($event)"></polar-chart>
  </div>
  <div class="exlist-info">{{exList.length!=0 ? exList[0].cl_reg_time + ' 운동 확인' : '프로그램을 등록해주세요.'}}</div>
  <div class="exlist-box" *ngIf="exList.length!=0">
    <div [ngClass]="{'border-bottom':i<2, 'border-right':i%2==0}" class="exlist" *ngFor="let ex of exList let i=index" (click)="exDetail(ex)">
      <img class="image" [src]="getBrainBall(ex.ec_num,ex.e_num)">
      <div class="name">
        {{ex.e_num==67 || ex.e_num==73 || ex.e_num==79 || ex.e_num==84 || ex.e_num==89 ? '운동검사' :
          (ex.e_num==68 || ex.e_num==74 || ex.e_num==80 || ex.e_num==85 || ex.e_num==90 ? '검사운동' : ex.ec_name)}}<br>
        <span>{{ex.e_name}}</span>
      </div>
      <div class="icon-wrap">
        <img class="icon" [src]="ss.setArrowColor(ex.ec_num,ex.e_num)">
      </div>
    </div>
  </div>
  <div class="empty-box" *ngIf="exList.length==0">
    <div class="picture-wrap">
      <img class="img" [src]="requestExerciseImage('0')">
    </div>
    <div class="empty-explain">
      <div class="title">{{getExerciseMessage()[0]}}</div>
      <div class="explain">{{getExerciseMessage()[1]}}</div>
    </div>
  </div>
</div>
